module.exports = __webpack_public_path__ + "img/qualityJewellery.77ecb3b.jpg";